module.exports = __webpack_public_path__ + "static/codegoodworks-512x512-18e46a1b0432fa9ee19f50dac1b823c7.png";